import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/content';
import { formatShortDate } from '@/utils/content';

interface PosterCardProps {
  item: ContentItem;
  showTrailer?: boolean;
}

export default function PosterCard({ item, showTrailer = true }: PosterCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200">
      <Link to={`/detail/${item.id}`} className="relative block aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} - ${item.tag}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50 dark:text-foreground-950">
          {item.tag}
        </span>
        {showTrailer && (
          <span className="absolute bottom-3 left-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-3 py-1 text-xs text-background-50 backdrop-blur-sm">
            <i className="ri-play-circle-fill text-accent-400"></i>
            预告片
          </span>
        )}
        <span className="absolute inset-0 flex items-center justify-center bg-foreground-950/0 transition-colors duration-300 group-hover:bg-foreground-950/30">
          <i className="ri-play-fill text-4xl text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100"></i>
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="mb-2">
          <Link
            to={`/detail/${item.id}`}
            className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors hover:text-primary-600 md:text-base"
          >
            {item.title}
          </Link>
        </h3>
        <p className="mb-3 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="whitespace-nowrap">{formatShortDate(item.date)}</span>
          <span className="whitespace-nowrap">
            <i className="ri-fire-line mr-1"></i>
            {item.views > 9999 ? `${(item.views / 10000).toFixed(1)}万` : item.views}
          </span>
        </div>
      </div>
    </article>
  );
}